<template>
  <div>
    <div class="for-pc footer-container" :style="{ color: color, 'padding-bottom': '4px', 'padding-top': '4px' }">
      <div>{{ copyrightText }}</div>

      <template v-if="ICPID.length > 0">
        <div class="dot">·</div>
        <a href="https://beian.miit.gov.cn" target="_blank" :style="{ color: color }">{{ ICPID }}</a>
      </template>
      <template v-if="BeianID.length > 0">
        <div class="dot">·</div>
        <img :src="beianIcon" class="beian-icon" />
        <a :href="BeianUrl" target="_blank" :style="{ color: color }">{{ BeianID }}</a>
      </template>

      <template v-if="showDocs">
        <div class="dot">·</div>
        <a href="https://docs.8jinyun.com" target="_blank" :style="{ color: color }">使用文档</a>
      </template>
      <template v-if="showNativeClient">
        <span class="dot">·</span>
        <n-popover trigger="hover" placement="top">
          <template #trigger>
            <span style="cursor: pointer">客户端</span>
          </template>
          <n-list>
            <n-list-item>
              <template #prefix>
                <ec-icon name="logo/windows"></ec-icon>
              </template>
              <a :href="win64Url" target="_blank" style="color: #000">Window 64位</a>
            </n-list-item>
            <n-list-item>
              <template #prefix>
                <ec-icon name="logo/windows"></ec-icon>
              </template>
              <a :href="win32Url" target="_blank" style="color: #000">Window 32位</a>
            </n-list-item>
          </n-list>
        </n-popover>
      </template>
      <template v-if="showContact">
        <div class="dot">·</div>
        <n-popover trigger="hover" placement="top">
          <template #trigger>
            <span style="cursor: pointer">联系我们</span>
          </template>
          <div>
            <img :src="contactIcon" class="contact-icon" alt="wechat:bajin-tech" />
          </div>
        </n-popover>
      </template>
    </div>
    <div v-if="!hideInMobile" class="for-phone footer-container" :style="{ color: color }">
      <div class="flex-row-nowrap-start-start-center">
        <div>{{ copyrightText }}</div>
        <template v-if="showDocs">
          <div class="dot">·</div>
          <a href="https://docs.8jinyun.com" target="_blank" :style="{ color: color }">使用文档</a>
        </template>
      </div>
      <div class="flex-row-nowrap-start-start-center">
        <template v-if="ICPID.length > 0">
          <a href="https://beian.miit.gov.cn" target="_blank" :style="{ color: color }">{{ ICPID }}</a>
        </template>
        <template v-if="BeianID.length > 0">
          <div class="dot">·</div>
          <a :href="BeianUrl" target="_blank" :style="{ color: color }">{{ BeianID }}</a>
        </template>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue"
import beianIcon from "@/assets/img/beian.png"
import contactIcon from "@/assets/img/wechat-contact.webp"
import { useEnvStore } from "@/store/EnvStore"
import moment from "moment"

const props = withDefaults(
  defineProps<{
    color?: string
    hideInMobile?: boolean
  }>(),
  {
    color: "#000",
    hideInMobile: false,
  }
)

const ICPID = (window as any).eightcatty.footer.ICPID || ""
const BeianID = (window as any).eightcatty.footer.BeianID || ""
const BeianUrl = computed(() => {
  const code = (window as any).eightcatty.footer.BeianCode || ""
  if (code.length == 0) {
    return "https://beian.mps.gov.cn/#/query/webSearch"
  } else {
    return `https://beian.mps.gov.cn/#/query/webSearch?code=${code}`
  }
})
const win32Url = import.meta.env.VITE_DOWNLOAD_URL_WIN32
const win64Url = import.meta.env.VITE_DOWNLOAD_URL_WIN64
const showContact = true //(window as any).eightcatty.footer.showContact || false
const showDocs = (window as any).eightcatty.footer.showDocs || false
const showNativeClient = computed(() => {
  const show = (window as any).eightcatty.footer.showNativeClient || false
  return !envStore.isApp && show
})
const envStore = useEnvStore()
const copyrightText = computed(() => {
  const companyName = (window as any).eightcatty.footer.companyName || ""
  return `© 2021-${moment().format("YYYY")} ${companyName}`
})
</script>
<style scoped>
.contact-icon {
  width: 200px;
}
@media screen and (max-width: 768px) {
  .footer-container {
    font-size: 12px;
    height: 48px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  .beian-icon {
    width: 8px;
    margin-right: 4px;
  }

  .dot {
    margin-left: 4px;
    margin-right: 4px;
  }
}

@media screen and (min-width: 768px) {
  .dot {
    margin-left: 8px;
    margin-right: 8px;
  }

  .footer-container {
    font-size: 14px;
    height: 32px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  .beian-icon {
    width: 19px;
    margin-right: 4px;
  }
}
</style>
